import { createUseStyles } from 'react-jss'
import { lightGrey } from '../../../../styles/const/colors'

const useStyles = createUseStyles({
  facebookSocialPost: {
    width: 320,
    border: `1px solid ${lightGrey}`,
    margin: '0 auto',
    backgroundColor: '#fff',
    overflow: 'hidden',
    marginBottom: 20,
    wordWrap: 'break-word',
    boxSizing: 'border-box',
    fontFamily: 'Roboto, sans-serif',

    fontSize: 9,
    borderRadius: 3,

    '& p': {
      marginTop: 0
    }
  },
  header: {
    padding: 8,
    paddingBottom: 6
  },
  headerTop: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 8
  },
  headerTopLeft: {
    display: 'flex'
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around'
  },
  name: {
    fontSize: 11,
    fontWeight: 700,
    fontStyle: 'normal',
    letterSpacing: 'normal',
    minWidth: 55
  },
  postDate: {
    display: 'flex',
    alignItems: 'center'
  },
  earthIcon: {
    marginLeft: 3,
    width: 9
  },
  actionButton: {
    marginRight: 5,
    height: 20,
    width: 15
  },
  adText: {
    padding: '0 4px',
    fontSize: 9,
    lineHeight: '12px',
    color: '#000',
    whiteSpace: 'pre-wrap'
  },
  messageTags: {
    padding: '0 4px',
    lineHeight: '12px',
    color: '#395996'
  },
  footer: {
    padding: 5,
    display: 'flex',
    flexDirection: 'column',
    color: '#606770'
  },
  footerTop: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: 3,
    borderBottom: '1px solid #DADDE1'
  },
  reactions: {
    display: 'flex',
    alignItems: 'center'
  },
  reactionIcon: {
    width: 13
  },
  reactionNumber: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 2
  },
  footerRight: {
    display: 'flex',
    alignItems: 'center'
  },
  shares: {
    marginLeft: 2
  },
  footerBottom: {
    padding: '5px 10px 0'
  },
  footerButtons: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    maxHeight: 20
  },
  footerButton: {
    display: 'flex',
    fontWeight: 500
  },
  buttonIcon: {
    width: 10,
    height: 10,
    marginRight: 4
  }
})

export default useStyles
